module.exports = __webpack_public_path__ + "img/resized-20160625-191350.50d85b29.jpg";